const i = {
  "language-switch-inline": "language-switch-inline",
  "language-switch-inline__list": "language-switch-inline__list",
  "language-switch-inline__list-item": "language-switch-inline__list-item",
  "language-switch-inline__link": "language-switch-inline__link",
  "language-switch-inline__link--selected": "language-switch-inline__link--selected"
};
export {
  i as default
};
